import api from '@/api'

export default {
    
    getSurveyLists(params :survey.SurveyListRequest) : Promise<survey.SurveyListResponse> {    
        return api.post({
            url: `/Survey/Compose/api/Lists`,
            data: params
        })
    }, 

    deleteSurvey(surveyIds :number[]) : Promise<boolean> {
        return api.post({
            url: `/Survey/Compose/api/delete`,
            data: surveyIds
        })
    },

    /* 
    create & update
    surveyId 유무로 create & update 판단
    */
    insertSurveyMainInfo(params:survey.SurveyRequest) : Promise<survey.SurveyResponse>{
        return api.post({
            url: `/Survey/Compose/api/create`,
            data : params
        })
    },

    setSurveyApproval(params: survey.ApprovalRequest){
    return api.post({
            url: `/Survey/Compose/api/Approval`,
            data : params
        })
    },

    getSurveyById(surveyId :number) : Promise<survey.SurveyRequest> {
        return api.get({
            url: `/Survey/Compose/api/main?surveyId=${surveyId}`
        })
    },

    reuseSurveyById(surveyId:number, personCode:string) : Promise<number> {
        return api.get({
            url: '/Survey/Compose/api/reuse',
            params:{
                surveyId: surveyId,
                createdId: personCode
            }
        })
    },

    deleteHardSurvey(surveyIds :number[]) : Promise<boolean> {
        return api.post({
            url: `/Survey/Compose/api/hardDelete`,
            data: surveyIds
        })
    },

    insertSurveyQuestion(params:survey.SurveyQuestionRequest) : Promise<survey.SurveyQuestionResponse>{
          
        return api.post({
            url: `/Survey/Question/api/insert`,
            data : params
        })
    },

    deleteSurveyQuestion(questionId:number) : Promise<survey.SurveyQuestionResponse>{
          
        return api.get({
            url: `/Survey/Question/api/delete?surveyQuestionId=${questionId}`,
        })
    },

    surveyDetail(surveyId: number) : Promise<survey.SurveyDetailResponse>{
        return api.get({
            url: `/Survey/Compose/api/detail?surveyId=${surveyId}`
        }) 
    },
 
    insertSurveyExamlple(params : survey.SurveyExampleRequest ): Promise<survey.SurveyExampleResponse>{
        return api.post({
            url: `/Survey/Example/api/insert`,
            data : params
        })
    },

    deleteSurveyExample(surveyExampleId : number): Promise<boolean>{
        return api.get({
            url: `/Survey/Example/api/delete?surveyExampleId=${surveyExampleId}`
        })
    },

    setSurveyNowPosting(params: number):Promise<boolean>{
        return api.post({
            url: `/Survey/Compose/api/NowPosting`,
            data : {surveyId : params}
        })
    },

    setSurveyNowClosing(params: number):Promise<boolean>{
        return api.post({
            url: `/Survey/Compose/api/NowClosing`,
            data : {surveyId : params}
        })
    },

    setSurveyComposingStatus(params:survey.SurveySetComposingRequest):Promise<boolean>{
        return api.post({
            url: `/Survey/Compose/api/Composing`,
            data : params
        })
    },


    insertSurveyAnswer(params:survey.SurveyAnswerRequest):Promise<survey.SurveyAnswerResponse>{
        return api.post({
            url: `/Survey/Answer/api/create`,
            data : params
        })
    },

    getSurveyAnswerLists(params:number) : Promise<Array<survey.SurveyAnswerListResponse>> {
        return api.get({
            url: `/Survey/Answer/api/lists?surveyId=${params}`
        })
    },

    getSurveyCompletionLists(params:number): Promise<survey.SurveyCompletionListResponse> {
        return api.get({
            url: `/Survey/Compose/api/CompletedLists?surveyId=${params}` 
        })
    },

  
    getSurveyStatisticsLists(params:number) : Promise<survey.SurveyStatisticsListResponse> {
        return api.get({
            url: `/Survey/Answer/api/StatisticsLists?surveyId=${params}`
        })
    },

    getSurveyStatisticsDetailLists(params:number) : Promise<survey.SurveyStatisticsListDetailResponse> {
        return api.get({
            url: `/Survey/Answer/api/StatisticsDetailLists?surveyQuestionId=${params}`
        })
    },

    getParticipantCount(params: number): Promise<number> {
        return api.get({
            url: `/Survey/Answer/api/Participant?surveyId=${params}`
        })
    },

    getSurveyAttachmentList(fileCode : string): Promise<appbase.FileInfo[]>{
        return api.get({
            url: `/file/store/api/GetFilelist`,
            params: {
                code: fileCode
            }
        })
    },

    getOrgGrades(comCode:string): Promise<survey.OrgGrade[]> {
        return api.get({
            url: `/Survey/Compose/api/orgGrades?comCode=${comCode}`
        })
    },

    getOrgCompanys(): Promise<{companies : appbase.company.Info[]}> {
        return api.get({
            url: `/Common/Company/api/list`,
        })
    },

    uploadSurveyExampleFile(params:survey.UploadFileRequest) : Promise<any>{
     
       let formData = new FormData()
       formData.append("code",params.Code)
       formData.append("CodeValues", params.CodeValues)
       formData.append("file", params.File)
       formData.append("flowIdentifier", params.FlowIdentifier)
       formData.append("flowFilename", params.FlowFilename)
       formData.append("flowRelativePath", params.FlowRelativePath)
    
        return api.post({
            url: `/file/store/api/flow`,
            data : formData ,
            //form-data 헤더추가
            headers : { 'Content-Type': 'multipart/form-data'},
        }) 
    },


    downloadSurveyStatisticsExcelData(params:number) : void {
        const url = `${process.env.NODE_ENV === 'production' ? '/cm' : 'http://localhost:5000' }/Survey/Answer/api/exportToExcel?surveyId=${params}`
        //const url = `http://localhost:5000/Survey/Answer/api/exportToExcel?surveyId=${params}`
        window.open(url)
    },

}